import { Heading, Paragraph, Skeleton } from "@digdir/designsystemet-react";

export const EndreAvtaleFormSkeleton = () => {
  return (
    <div className="max-w-card flex flex-col gap-4 bg-balder-background-tinted border border-balder-border-subtle p-6 rounded-3xl">
      <div>
        <Heading>
          <Skeleton variant="text" width={15} />
        </Heading>
        <Paragraph>
          <Skeleton variant="text" width={40} />
        </Paragraph>
      </div>
      <div className="space-y-9">
        <div>
          <Heading>
            <Skeleton variant="text" width={15} />
          </Heading>
          <Paragraph>
            <Skeleton variant="text" width={40} />
          </Paragraph>
        </div>
        <div>
          <Heading>
            <Skeleton variant="text" width={15} />
          </Heading>
          <Paragraph>
            <Skeleton variant="text" width={80} />
          </Paragraph>
        </div>
        <div>
          <Heading>
            <Skeleton variant="text" width={15} />
          </Heading>
          <Paragraph>
            <Skeleton variant="text" width={80} />
          </Paragraph>
        </div>
        <div>
          <Heading>
            <Skeleton variant="text" width={15} />
          </Heading>
          <Paragraph>
            <Skeleton variant="text" width={80} />
          </Paragraph>
        </div>
        <div>
          <Heading>
            <Skeleton variant="text" width={15} />
          </Heading>
          <Paragraph>
            <Skeleton variant="text" width={80} />
          </Paragraph>
        </div>
        <div>
          <Heading>
            <Skeleton variant="text" width={15} />
          </Heading>
          <Paragraph>
            <Skeleton variant="text" width={80} />
          </Paragraph>
        </div>
      </div>
      <div>
        <Heading>
          <Skeleton variant="text" width={15} />
        </Heading>
        <Paragraph>
          <Skeleton variant="text" width={40} />
        </Paragraph>
      </div>
    </div>
  );
};
